export default __webpack_public_path__ + "static/media/landing-page-desktop.6692f099.svg";